import { CompositeView, LayoutView } from 'backbone.marionette';

import PageView from '../../../base/views/page';
import { SearchView } from '../../../base/views/search';

const ItemView = LayoutView.extend({
  tagName: 'tr',
  template: require('../../templates/transaction/row.html')
});

const TransactionListView = CompositeView.extend({
  tagName: 'table',
  className: 'datatable',
  template: require('../../templates/transaction/table.html'),
  childView: ItemView,
  childViewContainer: 'tbody',

  childViewOptions(model, index) {
    const className = index % 2 ? '' : 'alt';
    const inactive = model.canImport() ? '' : 'inactive';

    return {
      className: `${className} ${inactive}`
    };
  }
});

export const TransactionView = LayoutView.extend({
  template: require('../../templates/transaction/index.html'),

  regions: {
    transactions: '#table-hook',
    paging: '.page-hook',
    search: '.search-hook'
  },

  onShow() {
    const search = new SearchView({ collection: this.collection });
    const transactions = new TransactionListView({
      collection: this.collection
    });
    const page = new PageView({ collection: this.collection });

    this.showChildView('search', search);
    this.showChildView('transactions', transactions);
    this.showChildView('paging', page);
  }
});



// WEBPACK FOOTER //
// ./epayment/views/transaction/index.js